import { Outlet, ScrollRestoration } from "react-router-dom";
import Footer from "../components/Footer";
import NavBar from "../components/navbar/NavBar";
import { NavItem } from "../models/interfaces/nav-item";
import { PERMISSIONS } from "../auth/permissions";
import { useAuth } from "../auth/useAuth";
import useUserInformation from "../hooks/useUserInformation";
import { isDevelopmentEnv } from "../helpers/utils/misc.util";

function HomeLayout() {
  const { loggedIn } = useAuth();
  const { logoLink } = useUserInformation();

  const navItems: NavItem[] = [
    NavItem.create("Home", "/", [], !loggedIn),
    NavItem.create("Über uns", "/about-us", [], !loggedIn),
    NavItem.create("Ausfälle", "/school", [PERMISSIONS.CanViewSchoolArea]),
    NavItem.create("Vertretungsanfragen", "/teacher", [
      PERMISSIONS.CanViewTeacherArea,
    ]),
    NavItem.create("Meine Ausfälle", "/absences", [
      PERMISSIONS.CanViewTeacherArea,
    ]),
    NavItem.create("Erfassen", "/vacancy", [PERMISSIONS.CanViewTeacherArea]),
    NavItem.create("Lehrpersonen", "/teacher-overview", [
      PERMISSIONS.CanViewSchoolArea,
    ]),
    NavItem.create("Playground", "/playground", [], isDevelopmentEnv()),
  ];

  return (
    <>
      <NavBar
        className="sticky top-0 z-10 font-sans"
        navItems={navItems}
        logoLink={logoLink}
      ></NavBar>
      <main className="mx-auto min-h-[var(--viewportHeight)] max-w-screen px-5 lg:px-10">
        <Outlet></Outlet>
      </main>
      <Footer></Footer>
      <ScrollRestoration getKey={(location) => location.pathname} />
    </>
  );
}

export default HomeLayout;
